import { call } from '@redux-saga/core/effects'
import { toastr } from 'react-redux-toastr'

export default function* handleSuccessSaga(success: string) {
  yield call(toastr.success, 'Success', success)
}
